import { CSSObject, Theme } from '@mui/material'

import { ChipColor } from 'components/Chips/StatusChip/types'
import { KeyValueStatus } from 'features/globalSetup/api/types/workspaceKeyValueDTO'
import { GamConnectionOrderStatus } from 'features/workspace/types/gamConnectionOrderStatus'

export const chipColors: ChipColor<GamConnectionOrderStatus | KeyValueStatus> = (
  theme: Theme,
  status: GamConnectionOrderStatus | KeyValueStatus,
): CSSObject['backgroundColor'] => {
  switch (status) {
    case 'completed':
    case 'created':
      return theme.palette.success.main
    case 'failed':
    case 'notCreated':
      return theme.palette.grey[500]
    case 'inProgress':
      return theme.palette.warning.main
  }
}
